import React, { useState } from 'react';
import { Box, Modal, Typography } from '@mui/material';
import {
  FaRegCopy,
  FaShare,
  FaTelegram,
  FaViber,
  FaWhatsapp,
} from 'react-icons/fa';
import { SlSocialVkontakte } from 'react-icons/sl';
import styles from './ShareModal.module.css';
import {
  getTelegramTourLink,
  getViberTourLink,
  getVKTourLink,
  getWhatsAppTourLink,
} from '../../utils/hotelInfoUtils';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import DEPART_DIC from '../../constants/DepartDic';
import { Link } from 'react-router-dom';
import { IoArrowBackCircleOutline, IoCloseCircleOutline } from 'react-icons/io5';

export const ShareModal = ({ row, open, handleClose, isMobile = false }) => {
  const linkValue = `https://www.geograftour.com/tours/tour-info/${row.offer_id}`;
  const text = `*${row.hotel_name} ${row.star_id}⭐️*
${row.country_name}, ${row.town_name}, из ${DEPART_DIC[row.depart_id].name_from}
${row.dt1} ${row.nights} ночей
${row.price} руб за номер
Туристы: ${row.adult} взрослых
${
  row.child
    ? row.child === 1
      ? ', ' + row.child + ' ребенок'
      : ', ' + row.child + ' детей'
    : ''
}

Подробнее здесь:
https://www.geograftour.com/tours/tour-info/${row.offer_id}
`;

  const textWithIcons = `🏠*${row.hotel_name} ${row.star_id}⭐️*
✈️ ${row.country_name}, ${row.town_name}, из ${
    DEPART_DIC[row.depart_id].name_from
  }
📅${row.dt1} ${row.nights} ночей
🏷${row.price} руб за номер
👤 Туристы: ${row.adult} взрослых
${
  row.child
    ? row.child === 1
      ? ', ' + row.child + ' ребенок'
      : ', ' + row.child + ' детей'
    : ''
}

Подробнее здесь:
https://www.geograftour.com/tours/tour-info/${row.offer_id}
`;

  const [copied, setCopied] = useState(false);
  const [messengersState, setMessengersState] = useState(true);
  const [variant, setVariant] = useState('link');
  const [textAreaValue, setTextAreaValue] = useState(linkValue);

  const onClose = () => {
    setMessengersState(true);
    handleClose();
  };

  return (
    <Modal
      style={{
        height: '100vh',
        width: '100vw',
        position: 'fixed',
        overflow: 'auto',
      }}
      className={styles.modalContainer}
      onClose={onClose}
      open={open}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        styles={{ top: '-100px' }}
        className={`${
          isMobile ? styles.boxContainerMobile : styles.boxContainer
        }`}
      >
        {!messengersState ? (
          <IoArrowBackCircleOutline
            style={{
              position: 'absolute',
              top: '10px',
              left: '10px',
              color: 'gray',
              cursor: 'pointer',
            }}
            onClick={() => {
              setMessengersState(true);
            }}
            size={30}
          />
        ) : null}
        {messengersState && (
          <div
            onClick={() => {
              setMessengersState(false);
            }}
          >
            <div className={styles.titleAndCloseButtonContainer}>
              <Typography
                style={{ marginBottom: '20px', color: '#333' }}
                className={styles.modalTitle}
                variant="h6"
                component="h2"
              >
                Как вы хотите поделиться?
              </Typography>
              <IoCloseCircleOutline
                style={{
                  position: 'absolute',
                  top: '10px',
                  right: '10px',
                  color: 'gray',
                  cursor: 'pointer',
                }}
                onClick={() => {
                  onClose();
                }}
                size={30}
              />
            </div>
            <div className={styles.iconContainer}>
              <FaShare className={styles.icon} style={{ color: '#5c6672' }} />
              <span className={styles.iconText}>Ссылка и текст</span>
            </div>
          </div>
        )}

        {/*// ссылка и текст*/}
        {!messengersState && (
          <>
            <div className={styles.titleAndCloseButtonContainer}>
              <Typography
                style={{ marginBottom: '20px', color: '#333' }}
                className={styles.modalTitle}
                variant="h6"
                component="h2"
              >
                Поделиться ссылкой и текстом
              </Typography>
              <IoCloseCircleOutline
                onClick={() => {
                  onClose();
                }}
                className={styles.closeButton}
                size={30}
              />
            </div>
            <div className={styles.buttonVariants}>
              <div
                onClick={() => {
                  setTextAreaValue(linkValue);
                  setVariant('link');
                  setCopied(false);
                }}
                className={
                  variant === 'link'
                    ? `${styles.buttonActiveVariant} ${styles.buttonVariant}`
                    : styles.buttonVariant
                }
              >
                ссылка
              </div>
              <div
                onClick={() => {
                  setTextAreaValue(text);
                  setVariant('text');
                  setCopied(false);
                }}
                className={
                  variant === 'text'
                    ? `${styles.buttonActiveVariant} ${styles.buttonVariant}`
                    : styles.buttonVariant
                }
              >
                текст
              </div>

              <div
                onClick={() => {
                  setTextAreaValue(textWithIcons);
                  setVariant('icons');
                  setCopied(false);
                }}
                className={
                  variant === 'icons'
                    ? `${styles.buttonActiveVariant} ${styles.buttonVariant}`
                    : styles.buttonVariant
                }
              >
                иконки
              </div>
            </div>
            <div>
              <textarea
                onChange={(e) => {
                  setTextAreaValue(e.currentTarget.value);
                }}
                value={textAreaValue}
                className={styles.textarea}
              ></textarea>
              <CopyToClipboard text={textAreaValue}>
                <div
                  onClick={() => {
                    setCopied(true);
                  }}
                  className={
                    copied === true
                      ? `${styles.buttonCopy} ${styles.success}`
                      : styles.buttonCopy
                  }
                >
                  <FaRegCopy />
                  Скопировать
                </div>
              </CopyToClipboard>
            </div>
          </>
        )}

        {/*// ссылки на мессенджеры*/}
        {messengersState && (
          <div>
            <Typography
              style={{ marginBottom: '20px', color: '#333' }}
              className={styles.modalTitle}
              id="modal-modal-title"
              variant="h6"
              component="h2"
            >
              Поделиться в 1 клик
            </Typography>
            <Link
              target={'_blank'}
              className={styles.link}
              to={getWhatsAppTourLink(row)}
            >
              <div className={styles.iconContainer}>
                <FaWhatsapp
                  className={styles.icon}
                  style={{ color: 'green' }}
                />
                <span className={styles.iconText}>WhatsApp</span>
              </div>
            </Link>

            <Link
              target={'_blank'}
              className={styles.link}
              to={getTelegramTourLink(row)}
            >
              <div className={styles.iconContainer}>
                <FaTelegram
                  className={styles.icon}
                  style={{ color: '#23ade0' }}
                />
                <span className={styles.iconText}>Telegram</span>
              </div>
            </Link>

            <Link
              target={'_blank'}
              className={styles.link}
              to={getVKTourLink(row)}
            >
              <div className={styles.iconContainer}>
                <SlSocialVkontakte
                  className={styles.icon}
                  style={{ color: '#3e93d8' }}
                />
                <span className={styles.iconText}>ВКонтакте</span>
              </div>
            </Link>
            <Link
              target={'_blank'}
              className={styles.link}
              to={getViberTourLink(row)}
            >
              <div className={styles.iconContainer}>
                <FaViber className={styles.icon} style={{ color: 'purple' }} />
                <span className={styles.iconText}>Viber</span>
              </div>
            </Link>
          </div>
        )}
      </Box>
    </Modal>
  );
};
